import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10dd22df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restore-backup-file" }
const _hoisted_2 = { class: "restore-wrapper" }
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = { class: "content-revealed" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "drop-info" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "file-name mb-8" }
const _hoisted_10 = { class: "pl-1" }

import { ref } from 'vue'

import { File } from '@/popup/components/shared/Form/Form'
import RestoreWizard from '@/popup/components/shared/Wizard.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import Notification from '@/popup/components/shared/Notification.vue'
import RestorePassword from '@/popup/components/Modal/RestorePassword.vue'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import {
  assertAndShowSomethingWentWrongError,
  useNotifications,
} from '@/popup/compositions/useNotifications'
import { InternalMethods } from '@/shared/apis/messages'
import { WrongPasswordError, ProfileDTO } from '@/business-logic/wallet'

type Emits = {
  (
    event: 'on-report-checked',
    profiles: ProfileDTO[],
    backupPassword: string,
    report: string
  ): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectFile',
  emits: ["on-report-checked"],
  setup(__props, { emit: __emit }) {

const { sendMessage } = useGlobals()
const { addSomethingWentWrongError } = useNotifications()

const emits = __emit

const progress = ref(20)
const errorMessage = ref<string>()
const invalidFile = ref(false)
const showPasswordModal = ref(false)
const filename = ref<string>()
const report = ref<string>()
const noProfilesAvailable = ref(false)

const onFileSelected = async (file: File) => {
  showPasswordModal.value = false
  report.value = await file.text()
  filename.value = file.name
  errorMessage.value = undefined
  invalidFile.value = false
  noProfilesAvailable.value = false
  progress.value = 50
}

const onRemoveFile = () => {
  showPasswordModal.value = false
  progress.value = 20
  errorMessage.value = undefined
  invalidFile.value = false
  noProfilesAvailable.value = false
  report.value = undefined
}

const onContinue = async () => {
  assertAndShowSomethingWentWrongError(
    report.value,
    'Expected report to be defined in SelectFile:onContinue()'
  )

  // check file with empty password first
  let profilesOrError = await sendMessage({
    method: InternalMethods.CHECK_BACKUP_FILE,
    payload: {
      report: report.value,
      backupPassword: '',
    },
  })

  if (!profilesOrError.success) {
    const { error } = profilesOrError
    if (error === WrongPasswordError.name) {
      showPasswordModal.value = true
      return
    }
    // BackupReportParseError
    invalidFile.value = true
    return
  }

  const profiles = profilesOrError.result

  if (profiles.length === 0) {
    noProfilesAvailable.value = true
    return
  }

  emits('on-report-checked', profiles, '', report.value)
}

const onPasswordSubmit = async (
  backupPassword: string
): Promise<{ passwordCorrect: boolean }> => {
  assertAndShowSomethingWentWrongError(
    report.value,
    'Expected report to be defined in SelectFile:onPasswordSubmit()'
  )

  // check file with backup password
  let profilesOrError = await sendMessage({
    method: InternalMethods.CHECK_BACKUP_FILE,
    payload: {
      report: report.value,
      backupPassword,
    },
  })

  if (!profilesOrError.success) {
    const { error } = profilesOrError
    if (error === WrongPasswordError.name) {
      return { passwordCorrect: false }
    }
    showPasswordModal.value = false
    // The file should have already been parsed when checking the empty password
    await addSomethingWentWrongError('Error parsing backup file.')
    return { passwordCorrect: true }
  }

  showPasswordModal.value = false

  const profiles = profilesOrError.result

  if (profiles.length === 0) {
    noProfilesAvailable.value = true
    return { passwordCorrect: true }
  }

  emits('on-report-checked', profiles, backupPassword, report.value)
  return { passwordCorrect: true }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RestoreWizard, {
        title: _ctx.$t('restore_wizard.upload_backup'),
        progress: progress.value
      }, null, 8 /* PROPS */, ["title", "progress"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (invalidFile.value)
              ? (_openBlock(), _createBlock(Notification, {
                  key: "invalidFile",
                  type: "error",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('restore_wizard.invalid_file_error')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (noProfilesAvailable.value)
              ? (_openBlock(), _createBlock(Notification, {
                  key: "noProfilesAvailable",
                  type: "error",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('restore_wizard.already_imported')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(SvgIcon, {
              name: "new-json-file",
              class: "mx-auto mb-2",
              fill: "--neutral-60"
            }),
            (!report.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!errorMessage.value)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          "data-testid": "drag-and-drop-info",
                          class: "mb-6",
                          innerHTML: _ctx.$t('restore_wizard.upload_backup_drag_and_drop')
                        }, null, 8 /* PROPS */, _hoisted_7))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createVNode(_unref(File), {
                    name: "restore-backup",
                    "file-type": "application/json",
                    onOnFileSelected: onFileSelected
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(filename.value), 1 /* TEXT */),
                  _createElementVNode("button", {
                    "data-testid": "remove-file-btn",
                    class: "button is-text remove-file px-2",
                    onClick: onRemoveFile
                  }, [
                    _createVNode(SvgIcon, {
                      name: "close-lg",
                      class: "is-flex",
                      height: "16",
                      width: "16"
                    }),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('restore_wizard.remove_file')), 1 /* TEXT */)
                  ])
                ]))
          ])
        ]),
        _createVNode(Button, {
          class: "mt-6",
          variant: "primary",
          "is-full-width": true,
          disabled: !report.value || invalidFile.value || noProfilesAvailable.value,
          onClick: onContinue
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('qr_code.scan.textarea_submit')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ])
    ]),
    (showPasswordModal.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createVNode(ModalTransition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(RestorePassword, {
                "on-cancel": onRemoveFile,
                "on-continue": onPasswordSubmit
              }, null, 512 /* NEED_PATCH */), [
                [_vShow, showPasswordModal.value]
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})